<template>
  <section>
    <form method="post" @submit.prevent="onSend">
      <b-field horizontal :label="$t('attributes.travel_group')" class="mt-2">
        <b-field
          :label="$t('attributes.group_code')"
          label-position="on-border"
        >
          <b-input v-model="group_code" disabled expanded></b-input>
        </b-field>

        <b-field
          :label="$t('attributes.product_code')"
          label-position="on-border"
        >
          <b-input v-model="product_code" disabled expanded></b-input>
        </b-field>

        <b-field :label="$t('attributes.area')" label-position="on-border">
          <b-input v-model="area_name" disabled expanded></b-input>
        </b-field>

        <b-field :label="$t('attributes.days')" label-position="on-border">
          <b-input v-model="days" numeric disabled expanded></b-input>
        </b-field>

        <b-field
          :label="$t('attributes.departure_date')"
          label-position="on-border"
        >
          <b-input v-model="departure_date" disabled expanded></b-input>
        </b-field>
      </b-field>

      <form-wrapper :validator="$v.form">
        <form-group horizontal name="name" :label="$t('attributes.name')">
          <b-input
            v-model="form.name"
            name="name"
            :placeholder="$t('message.please_input') + $t('attributes.name')"
            expanded
          ></b-input>
        </form-group>

        <form-group
          horizontal
          name="english_name"
          :label="$t('attributes.english_name')"
        >
          <b-input
            v-model="form.english_name"
            name="english_name"
            :placeholder="
              $t('message.please_input') + $t('attributes.english_name')
            "
            expanded
          ></b-input>
        </form-group>

        <form-group
          horizontal
          name="alias"
          attribute="attributes.sub_title"
          :label="$t('attributes.sub_title')"
        >
          <b-field>
            <b-input
              v-model="form.alias"
              name="alias"
              :placeholder="
                $t('message.please_input') + $t('attributes.sub_title')
              "
              expanded
            >
            </b-input>
            <p class="control">
              <a
                :href="helpImageUrl('副標題.png')"
                @click.prevent="onClickImage(helpImageUrl('副標題.png'))"
              >
                <img
                  :src="helpImageUrl('副標題.png')"
                  alt="副標題"
                  width="128"
                />
              </a>
            </p>
          </b-field>
        </form-group>

        <b-field horizontal>
          <template #label>
            {{ $t('attributes.operator_remark') }}
            <b-tooltip
              type="is-dark"
              :label="$t('attributes.operator_remark_label')"
            >
              <b-icon size="is-small" icon="help-circle-outline"></b-icon>
            </b-tooltip>
          </template>
          <form-group
            name="remark5"
            attribute="attributes.operator_remark"
            expanded
          >
            <b-input
              v-model="form.remark5"
              name="remark5"
              :placeholder="
                $t('message.please_input') +
                  $t('attributes.operator_remark') +
                  $t('attributes.operator_remark_max_length')
              "
              expanded
            ></b-input>
            <p class="control">
              <a
                :href="helpImageUrl('團控表備註.png')"
                @click.prevent="onClickImage(helpImageUrl('團控表備註.png'))"
              >
                <img
                  :src="helpImageUrl('團控表備註.png')"
                  alt="團控表備註"
                  width="64"
                />
              </a>
            </p>
          </form-group>
        </b-field>

        <b-field horizontal :label="$t('attributes.status')" class="mt-4">
          <form-group
            name="shelve_on"
            attribute="attributes.shelve_status"
            class="mt-1"
          >
            <b-switch
              v-model="form.shelve_on"
              name="shelve_on"
              :disabled="travelGroup.is_deprecated"
            >
              {{ $t('attributes.shelve_status') }}
            </b-switch>
          </form-group>

          <form-group
            name="situation"
            :label="$t('attributes.situation')"
            label-position="on-border"
          >
            <b-select v-model="form.situation" name="situation">
              <option
                v-for="option in situationTypes"
                :key="option.id"
                :value="option.id"
              >
                <!-- eslint-disable-next-line -->
              <p v-html="option.name"></p>
              </option>
            </b-select>
          </form-group>

          <form-group
            name="airline"
            :label="$t('attributes.airline')"
            label-position="on-border"
          >
            <b-autocomplete
              ref="airlineInput"
              v-model="selectedAirline"
              name="airline"
              field="display_name"
              :data="airlines"
              :placeholder="
                $t('message.please_input') + $t('attributes.airline')
              "
              :open-on-focus="true"
              @typing="onSelectingAirline"
              @select="onSelectedAirline"
            >
              <template #default="props">
                <div class="media">
                  <div class="media-left" style="width: 20px">
                    {{ props.option.code }}
                  </div>
                  <div class="media-content">
                    {{ props.option.name }}({{ props.option.english_name }})
                  </div>
                </div>
              </template>
              <template #empty>
                No results found
              </template>
            </b-autocomplete>
          </form-group>
        </b-field>

        <form-group
          horizontal
          name="attribute"
          :label="$t('attributes.attribute')"
        >
          <b-taginput
            v-model="selectedAttributes"
            :data="filteredTags"
            autocomplete
            field="name"
            icon="label"
            :open-on-focus="focus"
            :placeholder="
              $t('message.please_input') +
                $t('attributes.attribute') +
                $t('attributes.name')
            "
            :before-adding="beforeAdding"
            @typing="getFilteredTags"
          >
            <template v-slot="props">
              {{ props.option.name }}
            </template>
            <template #empty>
              There are no items
            </template>
          </b-taginput>
        </form-group>

        <form-group
          horizontal
          name="doc_url"
          attribute="attributes.pdf_url"
          :label="$t('attributes.pdf_url')"
        >
          <b-input
            v-model="form.doc_url"
            name="doc_url"
            :placeholder="$t('message.please_input') + $t('attributes.pdf_url')"
            expanded
          ></b-input>
        </form-group>

        <form-group
          horizontal
          name="external_url"
          :label="$t('attributes.external_url')"
        >
          <b-input
            v-model="form.external_url"
            name="external_url"
            :placeholder="
              $t('message.please_input') + $t('attributes.external_url')
            "
            expanded
          ></b-input>
        </form-group>

        <form-group
          v-if="isFirmGroup(type)"
          horizontal
          name="orientation_url"
          :label="$t('attributes.orientation_url')"
        >
          <b-input
            v-model="form.orientation_url"
            name="orientation_url"
            :placeholder="
              $t('message.please_input') + $t('attributes.orientation_url')
            "
          ></b-input>
        </form-group>

        <form-group
          v-if="isFirmGroup(type)"
          horizontal
          name="menu_url"
          :label="$t('attributes.menu_url')"
        >
          <b-input
            v-model="form.menu_url"
            name="menu_url"
            :placeholder="
              $t('message.please_input') + $t('attributes.menu_url')
            "
          ></b-input>
        </form-group>

        <b-field horizontal>
          <template #label>
            {{ $t('attributes.group_types') }}
            <b-tooltip type="is-dark" label="團型">
              <b-icon size="is-small" icon="help-circle-outline"></b-icon>
            </b-tooltip>
          </template>
          <form-group name="group_type">
            <b-select v-model="form.group_type" name="group_type">
              <option value="國外正規團">
                {{ $t('attributes.abroad_regular_group') }}
              </option>
              <option value="郵輪團">
                {{ $t('attributes.cruise_ship_group') }}
              </option>
              <option value="國內正規團">
                {{ $t('attributes.domestic_group') }}
              </option>
              <option value="自組團">
                {{ $t('attributes.self_organized_group') }}
              </option>
              <option value="專案優惠團">
                {{ $t('attributes.project_discount_group') }}
              </option>
              <option value="PAK團">
                {{ $t('attributes.pak_group') }}
              </option>
            </b-select>
          </form-group>
        </b-field>

        <b-field horizontal grouped>
          <b-button
            :loading="sending"
            type="is-primary"
            native-type="submit"
            style="width: 100%"
          >
            {{ $t('attributes.update_data') }}
          </b-button>
          <b-button
            v-if="hasPermission(PERMISSION_TYPE.TravelGroupsDelete)"
            :loading="sending"
            type="is-danger"
            icon-left="delete"
            style="width: 100%"
            @click.prevent.stop="onDelete"
          >
            {{ $t('attributes.delete') }}
          </b-button>
          <b-button
            v-if="travelGroup.is_collaborate_travel_group"
            :loading="sending"
            :disabled="travelGroup.is_deprecated"
            type="is-warning"
            icon-left="delete"
            style="width: 100%"
            @click.prevent.stop="onDeprecated"
          >
            {{ $t('attributes.deprecated') }}
          </b-button>
        </b-field>
      </form-wrapper>
    </form>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { debounce } from 'lodash'
import { required, maxLength } from 'vuelidate/lib/validators'
import { AIRLINE_API, ATTRIBUTES_API, TRAVEL_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'TravelGroupBasicForm',

  props: {
    travelGroup: {
      required: true,
      type: Object
    },
    type: {
      required: true,
      type: String,
      default: 'normal'
    },
    situationTypes: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      sending: false,

      group_code: this.travelGroup.code,
      product_code: this.travelGroup.product_code,
      area_name: this.travelGroup.area_name,
      days: this.travelGroup.days,
      departure_date: this.formatDate(this.travelGroup.departure_date),

      form: this.extractFormValues(this.travelGroup),

      airlines: [],
      selectedAirline: null,

      filteredTags: [],
      attributes: [],
      selectedAttributes: this.extractSelectedAttributeValues(
        this.travelGroup.travel_group_attributes
      ),
      focus: true,

      isImageModalActive: false,
      selectedImageUrl: null
    }
  },
  validations: {
    form: {
      name: { required },
      english_name: { maxLength: maxLength(50) },
      alias: { maxLength: maxLength(100) },
      remark5: {},
      airline: {},
      shelve_on: {},
      situation: {},
      attributes: {},
      doc_url: { maxLength: maxLength(500) },
      external_url: { maxLength: maxLength(500) },
      orientation_url: { maxLength: maxLength(500) },
      menu_url: { maxLength: maxLength(500) },
      departure_status: {},
      group_status: {},
      group_type: { maxLength: maxLength(20) }
    }
  },
  computed: {
    ...mapGetters('app', ['hasPermission'])
  },
  watch: {
    travelGroup(newGroup) {
      this.group_code = newGroup.code
      this.product_code = newGroup.product_code
      this.area_name = newGroup.area_name
      this.days = newGroup.days
      this.departure_date = this.formatDate(newGroup.departure_date)

      this.form = this.extractFormValues(newGroup)
      this.selectedAttributes = this.extractSelectedAttributeValues(
        newGroup.travel_group_attributes
      )

      this.selectedAirline = null
      this.getAirlines(this.form.airline)
    }
  },
  mounted() {
    this.getAirlines(this.form.airline)
    this.getAttributes()
  },
  methods: {
    extractFormValues(data) {
      return {
        name: data.name,
        english_name: data.english_name,
        alias: data.alias,
        remark5: data.remark5,
        shelve_on: data.shelve_on,
        airline: data.airline,
        situation: data.situation,
        attributes: [],
        doc_url: data.doc_url,
        external_url: data.external_url,
        orientation_url: data.orientation_url,
        menu_url: data.menu_url,
        departure_status: data.departure_status,
        group_status: data.group_status,
        group_type: data.group_type
      }
    },
    extractSelectedAttributeValues(data) {
      let array = []
      if (!data) {
        return []
      }
      data.forEach(item => {
        array.push(item.attributes)
      })
      return array
    },
    onSelectingAirline: debounce(function(search) {
      this.getAirlines(search)
    }, 500),
    onSelectedAirline(option) {
      this.form.airline = option && option.code.trim()
    },
    async getAirlines(search) {
      const api = `${AIRLINE_API}/list`
      const params = {
        search: search
      }

      try {
        const res = await this.axios.get(api, { params })
        this.airlines = res.data.data.map(air => ({
          ...air,
          code: air.code.trim(),
          name: air.name.trim(),
          english_name: air.english_name ? air.english_name.trim() : '',
          display_name: this.formatAirlineName(air)
        }))

        if (!this.selectedAirline) {
          const air = this.airlines.find(a => a.code === search)
          this.selectedAirline = air && air.display_name
        }
      } catch (e) {
        this.airlines = []

        notifyService.fetch_error('airline', e)
      }
    },
    async getAttributes() {
      const api = `${ATTRIBUTES_API}/list`
      try {
        const res = await this.axios.get(api)
        this.attributes = res.data.data
        this.filteredTags = this.attributes
      } catch (e) {
        this.attributes = []
        this.filteredTags = []
        notifyService.fetch_error('attribute', e)
      }
    },
    getFilteredTags(text) {
      this.filteredTags = this.attributes.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0
        )
      })
    },
    beforeAdding(tag) {
      let obj = []
      obj = this.selectedAttributes.find(function(item) {
        return item.id === tag.id
      })
      if (obj === undefined) {
        return tag
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      const api = `${TRAVEL_GROUPS_API}/${this.group_code}/basic`

      this.sending = true
      try {
        this.form.attributes = this.selectedAttributes
        const res = await this.axios.put(api, this.form)

        this.$emit('updated', res.data.data)
        notifyService.success(`${this.$t('attributes.update_succeed')}`)
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    onDeprecated() {
      this.$buefy.dialog.confirm({
        message: this.$t('attributes.confirm_deprecated'),
        onConfirm: () => {
          this.deprecatedGroup()
        }
      })
    },
    async deprecatedGroup() {
      const api = `${TRAVEL_GROUPS_API}/${this.group_code}/deprecate`

      this.sending = true
      try {
        const res = await this.axios.put(api)

        this.$emit('deprecated', res.data.data)
        notifyService.success(this.$t('attributes.deprecate_succeed'))
      } catch (e) {
        notifyService.deprecate_error(e)
      } finally {
        this.sending = false
      }
    },
    onDelete() {
      this.$buefy.dialog.confirm({
        message: this.$t('attributes.confirm_delete'),
        onConfirm: () => {
          this.deleteGroup()
        }
      })
    },

    async deleteGroup() {
      const api = `${TRAVEL_GROUPS_API}/${this.group_code}`

      this.sending = true
      try {
        await this.axios.delete(api)

        this.$emit('deleted', this.group_code)
        notifyService.success(this.$t('attributes.delete_succeed'))
      } catch (e) {
        notifyService.delete_error(e)
      } finally {
        this.sending = false
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    }
  }
}
</script>

<style lang="scss" scoped>
.select {
  select {
    width: 150px;
  }
}
</style>
